import apiClient from "../api/apiClient";

export const getAllUsers = async () => {
  try {
    let res = await apiClient.get(`/admin/getAllUsers`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateTrainingProConfig = async (
  userUUID,
  trainingProConfig,
  date
) => {
  console.log("Training pro config:", trainingProConfig);

  try {
    const configURL = `user/${userUUID}/training-config/${date}`;

    const response = await apiClient.post(
      configURL, //`/user/${userUUID}/training-config/${date}`,
      trainingProConfig
    );

    console.log("Training pro config updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating training pro config:", error.message);
    throw error;
  }
};

export const fetchTrainingProConfig = async (userUUID, date) => {
  try {
    const configURL = `user/${userUUID}/training-config/${date}`;
    let response = await apiClient.get(configURL);
    let trainingConfig = response.data.training_config;
    return trainingConfig;
  } catch (error) {
    console.log(
      `Failed Fetching User Training Pro Config with error: ${error}`
    );
  }
};

export const fetchTrainingProConfigHistory = async (userUUID) => {
  try {
    const configURL = `user/${userUUID}/training-config`;
    let response = await apiClient.get(configURL);
    let trainingConfig = response.data.training_config;
    return trainingConfig;
  } catch (error) {
    console.log(
      `Failed Fetching User Training Pro Config with error: ${error}`
    );
  }
};

